import React from 'react';
import './ProgramatorLuni.css'

import { Fab, Button, Hidden } from '@material-ui/core';
import SpecificComponent from '../SpecificComponent';
import Utils from '../../providers/Utils';

export default class RaportAngajat extends SpecificComponent {

    constructor(props) {
        super(props);

        this.state = {
            title: '',

        }

    }




    monthDisplay = (luna, anul) => {

        let monthBegin = new Date(anul, (luna - 1), 1) // js index luna este 0
        let monthEnd = new Date(anul, luna, 0)

        // console.log('Inceput luna este -> ', monthBegin )
        // console.log('Sfarsit luna este -> ', monthEnd )

        let beginFor = this.getWeekNumber(monthBegin, luna);
        let endFor = this.getWeekNumber(monthEnd, luna);



        // console.log('begin for =',beginFor);
        // console.log('end for = ',endFor);

        let tbodyContent = []
        let _td = new Date()
        let _day = 0;

        for (let i = beginFor; i <= endFor; i++) {
            let cols = []

            for (let k = 1; k <= 7; k++) {

                let celContent = []

                for (let j = 0; j < monthEnd.getDate(); j++) {

                    _td = this.addDays(monthBegin, j)
                    _day = _td.getDay() === 0 ? 7 : _td.getDay()

                    if (this.getWeekNumber(_td, luna) === i && _day === k) {
                        // doar display brut de calendar
                        //celContent.push(<label key={`i=${i}k=${k}j=${j}`}>{_td.getDate()}</label>)
                        // console.log('this.props.dataProgramare :', this.props.dataProgramare.substring());
                        // console.log('_td :', _td);
                        celContent.push(<div  style={{ backgroundColor: this.props.dataProgramare === `${anul}-${luna < 10 ? '0' + luna : luna}-${j + 1 < 10 ? "0" + (j + 1) : j + 1}` ? 'rgba(166, 239, 166, 0.74)' : 'white', overflow: 'hidden', position: 'relative' }} className={_day >= 6 ? 'monthcalendar-weekend-class' : 'monthcalendar-weekday-class'} key={`i=${i}k=${k}j=${j}`}>
                            <label className={_day >= 6 ? 'monthcalendar-weekend-label' : 'monthcalendar-weekday-label'} > {_td.getDate()} </label>

                            <Button style={{ display: 'block', backgroundColor: this.filterColor(_td), minHeight: 19, margin: 'auto' }} onClick={() => { console.log('raportClicked')}} >

                                <span style={{ color: 'white' }}>{this.filterLabel(_td)}</span>
                            </Button>




                            {/* {
                                             this.filterLabelEvents(_td, i, k, monthEnd.getDate()) 
                                             }   */}

                        </div>)
                    }
                }

                cols.push(<td key={`w${i}d${k}`}> {celContent}  </td>)
            }

            tbodyContent.push(<tr key={`w${i}`}>{cols}</tr>)
        }


        // console.log('body content',tbodyContent);
        return tbodyContent
    }



    getWeekNumber = (d, luna) => {

        d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
        let dayNum = d.getUTCDay() || 7
        d.setUTCDate(d.getUTCDate() + 4 - dayNum);
        var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
        var weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);

        if (weekNo === 1 && luna === 12) {
            let ld = new Date(d.getFullYear(), 11, 24);
            return this.getWeekNumber(ld) + 1
        } else {
            return weekNo
        }
    }

    ajustareSfarsitAn = (anul) => {
        return this.weeksInYear(anul) + 1
    }

    weeksInYear = (year) => {
        var d = new Date(year, 11, 31);
        var week = this.getWeekNumber(d);
        // console.log('saptamana :', week);
        if (week === 1) {
            d.setDate(24)
            return this.getWeekNumber(d)
        } else {
            return week
        }

    }





    daysInMonth = (month, year) => {

        return new Date(year, month, 0).getDate();
    }

    addDays = (date, days) => {

        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    filterLabel = (dt) =>{
        if (this.props.scop === 'angajat') {
            let u = new Utils();
            let dataCalendar = u.transformDataForSql(dt);

            let cloneEvents = this.props.events

            let prezenta = []
            let counter = cloneEvents.length

            // console.log('cloneEvents :', cloneEvents);

            for (let i = 0, n = cloneEvents.length; i < n; i++) {
                cloneEvents[i].la_data = u.ParseDataFromSql(cloneEvents[i].la_data)


                if (cloneEvents[i].la_data === dataCalendar) {
                    prezenta.push(cloneEvents[i])

                }

               


            }

            let concediu = cloneEvents.findIndex(c => dataCalendar >= u.ParseDataFromSql(c.cand_inceput_dataC) && dataCalendar <= u.ParseDataFromSql(c.cand_sfarsit_dataC)  )

            let procent = 0
      

            if (prezenta.length > 0) {
                procent = prezenta[0].nr_ore_lucrate / 8 * 100
                
            }
            //  console.log('concediu :', concediu);

            if (procent > 100) {
                return prezenta[0].nr_ore_lucrate + ' ore'
            } else if (procent === 100) {
                return prezenta[0].nr_ore_lucrate + ' ore'
            } else if (procent < 100 && procent > 0) {
                return prezenta[0].nr_ore_lucrate + ' ore'
            }else if (concediu !== -1){
                // console.log('concediu :',cloneEvents[concediu] );

                let tipConcediu = this.props.tipConcedii.findIndex(t => t.id === cloneEvents[concediu].tip_concediu)

                if(tipConcediu !== -1){
                    return this.props.tipConcedii[tipConcediu].nume
                }else{

                    return '#5690d8'
                }
            } 
            
            else {
                return 'Absent'
            }

        }

    }

    filterColor = (dt) => {

        if (this.props.scop === 'angajat') {
            let u = new Utils();
            let dataCalendar = u.transformDataForSql(dt);

            let cloneEvents = this.props.events

            let prezenta = []
            let counter = cloneEvents.length

            // console.log('cloneEvents :', cloneEvents);

            for (let i = 0, n = cloneEvents.length; i < n; i++) {
                cloneEvents[i].la_data = u.ParseDataFromSql(cloneEvents[i].la_data)


                if (cloneEvents[i].la_data === dataCalendar) {
                    prezenta.push(cloneEvents[i])

                }

               


            }

            let concediu = cloneEvents.findIndex(c => dataCalendar >= u.ParseDataFromSql(c.cand_inceput_dataC) && dataCalendar <= u.ParseDataFromSql(c.cand_sfarsit_dataC)  )

            let procent = 0
      

            if (prezenta.length > 0) {
                procent = prezenta[0].nr_ore_lucrate / 8 * 100
                
            }
            //  console.log('concediu :', concediu);

            if (procent > 100) {
                return '#149514'
            } else if (procent === 100) {
                return '#21D621'
            } else if (procent < 100 && procent > 0) {
                return '#FF9300'
            }else if (concediu !== -1){
                // console.log('concediu :',cloneEvents[concediu] );

                let tipConcediu = this.props.tipConcedii.findIndex(t => t.id === cloneEvents[concediu].tip_concediu)

                if(tipConcediu !== -1){
                    return this.props.tipConcedii[tipConcediu].bkColor
                }else{

                    return '#5690d8'
                }
            } 
            
            else {
                return 'red'
            }

        }

        else {
            let u = new Utils();

            let dataCalendar = u.transformDataForSql(dt);

            let cloneEvents = this.props.events





            let prezenta = []
            let counter = cloneEvents.length

            for (let i = 0; i < counter; i++) {
                cloneEvents[i].la_data = u.ParseDataFromSql(cloneEvents[i].la_data)

                if (cloneEvents[i].la_data === dataCalendar) {
                    if (cloneEvents[i].prezenta !== 0) {

                        prezenta.push(cloneEvents[i])
                    }
                }

            }

            let procent = 0



            if (prezenta.length > 0) {
                procent = prezenta.length / this.props.totalAngajati.length * 100
            }


            if (procent >= 80) {
                return 'green'
            } else if (procent < 80 && procent > 50) {
                return 'orange'
            } else {
                return 'red'
            }




        }




    }

    numeLuna = (l) => {

        // console.log('l :', l);
        let rez = ''

        switch (l) {
            case 1: rez = this.dictionary.luni.ianuarie; break;
            case 2: rez = this.dictionary.luni.februarie; break;
            case 3: rez = this.dictionary.luni.martie; break;
            case 4: rez = this.dictionary.luni.aprilie; break;
            case 5: rez = this.dictionary.luni.mai; break;
            case 6: rez = this.dictionary.luni.iunie; break;
            case 7: rez = this.dictionary.luni.iulie; break;
            case 8: rez = this.dictionary.luni.august; break;
            case 9: rez = this.dictionary.luni.septembrie; break;
            case 10: rez = this.dictionary.luni.octombrie; break;
            case 11: rez = this.dictionary.luni.noiembrie; break;
            case 12: rez = this.dictionary.luni.decembrie; break;

        }

        return rez
    }


    render() {
        return (
            <div style={{ display: this.props.display, maxWidth: this.props.maxWidth }} className="monthcalendar-main-container">

                <div className='monthcalendar-header'>
                    <i onClick={this.props.minusLuna} className='material-icons' style={{ color: 'rgb(117, 234, 117)', verticalAlign: 'sub', cursor: 'pointer', fontSize: 20 }}>arrow_back</i>
                    <span className='monthcalendar-title'>{this.numeLuna(this.props.luna)} - {this.props.anul}</span>
                    <i onClick={this.props.plusLuna} className='material-icons' style={{ color: 'rgb(117, 234, 117)', verticalAlign: 'sub', cursor: 'pointer', fontSize: 20 }}>arrow_forward</i>
                </div>
                <div className="monthcalendar-table-container">


                    <table className='monthcalendar-table-class'>
                        <thead className='monthcalendar-tablehead-class'>
                            <tr className='monthcalendar-tableheadtr-class' >
                                <th style={{ color: 'rgb(117, 234, 117)', backgroundColor: 'white', fontSize: 15 }}>{this.dictionary.zileleSapt.luni}</th>
                                <th style={{ color: 'rgb(117, 234, 117)', backgroundColor: 'white', fontSize: 15 }}>{this.dictionary.zileleSapt.marti}</th>
                                <th style={{ color: 'rgb(117, 234, 117)', backgroundColor: 'white', fontSize: 15 }}>{this.dictionary.zileleSapt.miercuri}</th>
                                <th style={{ color: 'rgb(117, 234, 117)', backgroundColor: 'white', fontSize: 15 }}>{this.dictionary.zileleSapt.joi}</th>
                                <th style={{ color: 'rgb(117, 234, 117)', backgroundColor: 'white', fontSize: 15 }}>{this.dictionary.zileleSapt.vineri}</th>
                                <th style={{ color: 'white', backgroundColor: 'rgb(117, 234, 117)', fontSize: 15 }}>{this.dictionary.zileleSapt.sambata}</th>
                                <th style={{ color: 'white', backgroundColor: 'rgb(117, 234, 117)', fontSize: 15 }}>{this.dictionary.zileleSapt.duminica}</th>
                            </tr>
                        </thead>

                        <tbody>
                            {this.monthDisplay(this.props.luna, this.props.anul)}
                        </tbody>

                    </table>
                   

                </div>
            </div>
        );
    }


}  // end class